export enum EnergyCertMeasurementUnits {
    surroundingArea = 'MEASUREMENT_UNITS.M2',
    buildingVolume = 'MEASUREMENT_UNITS.M3',
    airExchangeRate = 'MEASUREMENT_UNITS.1_H',
    specificTransmissionHeatLoss = 'MEASUREMENT_UNITS.W_PER_M2K'
}
